export function hasUsdPrice(game) {
  return game != null && typeof game.costUSD === 'number';
}

export function usesUsdCheckout(game) {
  return hasUsdPrice(game) && game.costUSD > 0;
}

export function usesBundleUsdCheckout(bundle) {
  return bundle != null && typeof bundle.costUSD === 'number' && bundle.costUSD > 0;
}

export function isFreeGame(game) {
  if (hasUsdPrice(game)) {
    return game.costUSD === 0;
  }
  return !game.shards || game.shards === 0;
}

export function formatUsdPrice(amount) {
  return `$${amount.toFixed(2)}`;
}

export function getGamePriceDisplay(game, isOwned = false) {
  if (isOwned) {
    return { type: 'owned', label: 'PURCHASED' };
  }

  if (hasUsdPrice(game)) {
    if (game.costUSD === 0) {
      return { type: 'free', label: 'FREE' };
    }
    return {
      type: 'usd',
      label: formatUsdPrice(game.costUSD),
      strikethrough:
        game.isDiscounted && typeof game.preDiscountPriceUSD === 'number'
          ? formatUsdPrice(game.preDiscountPriceUSD)
          : null,
    };
  }

  if (game.shards === 0) {
    return { type: 'free', label: 'FREE' };
  }

  return { type: 'shards', label: `${game.shards} Shards` };
}

export function getBundlePriceDisplay(bundle) {
  const priceUsd = typeof bundle?.costUSD === 'number' ? bundle.costUSD : null;

  if (priceUsd != null) {
    if (priceUsd === 0) {
      return { type: 'free', label: 'FREE' };
    }
    return {
      type: 'usd',
      label: formatUsdPrice(priceUsd),
      strikethrough:
        bundle.isDiscounted && typeof bundle.preDiscountPriceUSD === 'number'
          ? formatUsdPrice(bundle.preDiscountPriceUSD)
          : null,
    };
  }

  if (!bundle.shards) {
    return { type: 'free', label: 'FREE' };
  }

  return { type: 'shards', label: `${bundle.shards} Shards` };
}
